import { useEffect } from 'react';

export function useThemeColor(backgroundColor: string) {
  useEffect(() => {
    const themeColor = backgroundColor;
    const { body, documentElement: html, head } = document;
    const themeMeta = document.querySelector('meta[name="theme-color"]');
    const previousBodyBackgroundColor = body.style.backgroundColor;
    const previousHtmlBackgroundColor = html.style.backgroundColor;
    const previousThemeColor = themeMeta?.getAttribute('content');
    body.style.backgroundColor = themeColor;
    html.style.backgroundColor = themeColor;
    if (themeMeta) {
      themeMeta.setAttribute('content', themeColor);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'theme-color';
      meta.content = themeColor;
      head.appendChild(meta);
    }
    return () => {
      body.style.backgroundColor = previousBodyBackgroundColor;
      html.style.backgroundColor = previousHtmlBackgroundColor;

      if (themeMeta) {
        if (previousThemeColor) {
          themeMeta.setAttribute('content', previousThemeColor);
        } else {
          themeMeta.removeAttribute('content');
        }
      } else {
        const createdThemeMeta = document.querySelector(
          'meta[name="theme-color"]'
        );
        if (createdThemeMeta) {
          head.removeChild(createdThemeMeta);
        }
      }
    };
  }, [backgroundColor]);
}
